import { render, staticRenderFns } from "./http404.vue?vue&type=template&id=21b4355f&scoped=true"
import script from "./http404.vue?vue&type=script&lang=js"
export * from "./http404.vue?vue&type=script&lang=js"
import style0 from "./http404.vue?vue&type=style&index=0&id=21b4355f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b4355f",
  null
  
)

export default component.exports